class Resource {
  constructor(id, categories = []) {
    this.id = id;
    this.categories = categories;
  }
}

export class ResourceList {
  perPage;
  attrPageNumber = "data-page";
  attrResourceId = "data-resource-id";
  attrResourceCategory = "data-resource-categories";
  attrFilterCategory = "data-filter-category";

  constructor(perPage = 6) {
    this.perPage = perPage;
    this.resourceList = this.loadResources();
    this.currentPage = 0;
    this.setResultingResources(this.resourceList);
    this.bindEvents();
  }

  bindEvents() {
    const pagingList = $(".resources-pagination-list");
    $(pagingList).find(".next-arrow").click(this.nextPage.bind(this));
    $(pagingList).find(".prev-arrow").click(this.previousPage.bind(this));
    const filterList = $(".resources-filter-list");
    $(filterList).find(`[${this.attrFilterCategory}]`).click((event) => {
      const target = event.target;
      $(filterList).find(".active").removeClass("active");
      $(target).addClass("active");
      this.filterByCategory($(target).attr(this.attrFilterCategory))
    })
  }

  setResultingResources(resourceList) {
    if (!resourceList.length) {
      this.showNoResult();
    }
    else {
      this.hideNoResult();
      this.currentPage = 0;
      this.pages = this.mapResources(resourceList);
      this.renderPagination();
      this.showPage(this.currentPage);
    }
  }

  mapResources(resourceList) {
    let pages = [];
    const totalPages = Math.ceil(resourceList.length / this.perPage);
    for (let i = 0; i < totalPages; i++) {
      const start = i * this.perPage;
      pages.push(resourceList.slice(start, start + this.perPage));
    }
    return pages;
  }

  loadResources() {
    let resourceList = [];
    $(".resource").each((index, elem) => {
      $(elem).attr(this.attrResourceId, index);
      const categories = $(elem).attr(this.attrResourceCategory).split("|").map(c => c.trim()) || [];
      resourceList.push(new Resource(index, categories));
    })
    return resourceList;
  }

  renderPagination() {
    const pagingList = $(".resources-pagination-list");
    $(pagingList).find(".page").remove();
    const nextArrow = $(pagingList).find(".next-arrow")
    for (let i = 0; i < this.pages.length; i++) {
      $(nextArrow).before(`<li class="page${i == this.currentPage ? ' active' : ''}" ${this.attrPageNumber}="${i}">${i + 1}</li>`);
    }
    $(pagingList).find(".page").on('click', (event) => {
      const elem = event.target;
      const page = parseInt($(elem).attr(this.attrPageNumber));
      if (page != this.currentPage) {
        this.showPage(page);
        this.scrollToList();
      }
    })
  }

  nextPage() {
    if (this.currentPage >= this.pages.length - 1) return;
    this.currentPage++;
    this.showPage(this.currentPage);
    this.scrollToList();
  }

  previousPage() {
    if (this.currentPage <= 0) return;
    this.currentPage--;
    this.showPage(this.currentPage);
    this.scrollToList();
  }

  showPage(page) {
    if (page >= this.pages.length) return;
    this.currentPage = page;
    const pagingList = $(".resources-pagination-list");
    $(pagingList).find(".page").siblings().removeClass("active");
    $(pagingList).find(`.page[${this.attrPageNumber}="${page}"]`).addClass("active");

    const ids = this.pages[page].map(c => c.id);
    $(".resource").each((index, elem) => {
      const id = $(elem).attr(this.attrResourceId);
      if (ids.indexOf(parseInt(id)) >= 0) $(elem).removeClass("hidden");
      else $(elem).addClass("hidden");
    })
  }

  scrollToList() {
    $('html, body').animate({
      scrollTop: $(".resources-list").offset().top - 300
    }, 300);
  }

  showNoResult() {
    $(".resources-list").hide();
    $(".resources-pagination").hide();
    $(".resources-no-result").show();
  }

  hideNoResult() {
    $(".resources-list").show();
    $(".resources-pagination").show();
    $(".resources-no-result").hide();
  }

  filterByCategory(category) {
    const matchingResources = category == "ALL" ? this.resourceList : this.resourceList.filter(r => r.categories.includes(category));
    this.setResultingResources(matchingResources);
  }

}

new ResourceList();